import { useEffect, useRef } from "react";
import { Chart, RadarController, RadialLinearScale, PointElement, LineElement, Filler } from "chart.js";
// import "./DilemaChart.css"

Chart.register(RadarController, RadialLinearScale, PointElement, LineElement, Filler);

// Donut ring: each segment covers 90deg (one per label: V, M, T, G)
// Colors: pink(V), purple(M), teal(T), mint/green(G)
const SEGMENT_COLORS = ["#E87DB8", "#A78BCC", "#60C5A8", "#98D4B8"];
const GAP_DEG = 4; // gap between segments in degrees
 
function polarToXY(cx, cy, r, angleDeg) {
  const rad = ((angleDeg - 90) * Math.PI) / 180;
  return [cx + r * Math.cos(rad), cy + r * Math.sin(rad)];
}

function describeArc(cx, cy, r, startDeg, endDeg) {
  const [x1, y1] = polarToXY(cx, cy, r, startDeg);
  const [x2, y2] = polarToXY(cx, cy, r, endDeg);
  const largeArc = endDeg - startDeg > 180 ? 1 : 0;
  return `M ${x1} ${y1} A ${r} ${r} 0 ${largeArc} 1 ${x2} ${y2}`;
}

function DilemaChart({ size = 200 }) {

     const cx = size / 2;
  const cy = size / 2;
  const outerR = size / 2 - 4;
  const innerR = outerR - 28;
  const strokeWidth = outerR - innerR;
  const r = (outerR + innerR) / 2;

  // 4 segments, each 90deg with a gap
  const segments = SEGMENT_COLORS.map((color, i) => {
    const startDeg = i * 90 + GAP_DEG / 2;
    const endDeg = (i + 1) * 90 - GAP_DEG / 2;
    return { color, startDeg, endDeg };
  });




  return (
    <svg
      className="donut-ring"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      style={{ position: "absolute", top: 0, left: 0 }}
    >
      {/* White background circle */}
      <circle cx={cx} cy={cy} r={outerR} fill="white" />
      {segments.map(({ color, startDeg, endDeg }, i) => (
        <path
          key={i}
          d={describeArc(cx, cy, r, startDeg, endDeg)}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="butt"
        />
      ))}
    </svg>
  );

}



export default DilemaChart











